import { Link } from "@tanstack/react-router";

import { BACK_LINK_CLASS, BackLink as HistoryBackLink } from "@/components/layout/BackLink";
import { lastSearch } from "@/components/layout/lastSearch";
import { TEST_RESULT_DEFAULT_SEARCH, TEST_RESULT_ROUTE } from "./testResultSearch";

/**
 * Test Result's way back — history first (the Matrix with its filters, the
 * summary, a Batch Test page's run log). With nothing to go back to, the
 * page's Matrix, with the Matrix's last filters.
 */
export function BackLink({ pageId, label }: { pageId: string | null; label: string | null }) {
  return (
    <HistoryBackLink
      fallback={
        <Link
          to={TEST_RESULT_ROUTE}
          search={{ ...lastSearch(TEST_RESULT_ROUTE, TEST_RESULT_DEFAULT_SEARCH), page: pageId, tc: null }}
          className={BACK_LINK_CLASS}
        >
          ← {label ? `${label} Matrix` : "Matrix"}
        </Link>
      }
    />
  );
}
